import React, { useEffect, useState, useContext } from 'react';
import YouTube from 'react-youtube';
import { collection, count, getDocs, getDoc, doc, query, where } from "firebase/firestore"; 
import { createOptions, db } from '../App';
import { GameContext } from '../context/globalContext';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import CircularProgress from '@mui/material/CircularProgress';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { useNavigate } from 'react-router-dom';

var playerTimeout

export default function Player({gamemode}) {
    const [songs, setSongs] = useState([])
    const [YTID, setYTID] = useState()
    const [player, setPlayer] = useState()
    const [playerStatus, setPlayerStatus] = useState(-1)
    const [showAnswer, setShowAnswer] = useState(false)
    const [isRight, setIsRight] = useState(null)
    const [lastUpdated, setLastUpdated] = useState(null)
    const [lives, setLives] = useState(null)
    const [livesCounter, setLivesCounter] = useState(null)
    
    const [options, setOptions] = useState(JSON.parse(localStorage.getItem('options')))
    const [volume, setVolume] = useState(options.defaultVolume)

    const { currentSong, setCurrentSong, score, setScore, answerContext, setSongIndex, songIndex, setSongsContext } = useContext(GameContext)

    let loaded = false
    const opts = {
      height: '360',
      width: '640',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: false,
      },
    };
    
    var duration; //seconds
    var guesstime = options.guessTime //seconds
    const songsCache = JSON.parse(localStorage.getItem("songs"))
    const lastUpdatedCache = JSON.parse(localStorage.getItem("lastUpdated"))
    
    async function fetchLastUpdated() {
      const docRef = doc(db, "lastUpdated", "songs");
      const docSnap = await getDoc(docRef);
      setLastUpdated(docSnap.data().lastUpdated)
    }

    function filterSong(song) {
      if(song.Type === 'original' && !options.songType.original) return false
      if(song.Type === 'cover' && !options.songType.cover) return false
      switch (song.Branch) {
        case 'en':
          if(options.branches.en) return true
          break
        case 'id':
          if(options.branches.id) return true
          break
        case 'jp':
          if(options.branches.jp) return true
          break
        case 'all':
          return true
        default:
          console.log(song.Branch)
          if(song.Branch.includes('en') && options.branches.en) {return true}
          else if(song.Branch.includes('id') && options.branches.id) {return true}
          else if(song.Branch.includes('jp') && options.branches.jp) {return true}
          break;
      }
    }

    useEffect(() => {
      fetchLastUpdated()
      if (gamemode === 'endless') {
        var maxLives
        if(!options.numberOfLives){
          maxLives = 3
          createOptions()
        }else{
          maxLives = options.numberOfLives
        }
        setLivesCounter(maxLives)
        renderLives(maxLives)
      }else if (gamemode === 'hardcore') {
        const maxLives = 1
        setLivesCounter(maxLives)
        renderLives(maxLives)
      }
    }, [])
    
    useEffect(() => {
      if(!loaded){

        var dbSongs = collection(db, "songs")
        //var q = query(dbSongs, where('Artist', 'array-contains', 'Hoshimachi Suisei'))

        async function fetchSongs() {
          const querySnapshot = await getDocs(dbSongs);
          let songsArray = []
          querySnapshot.forEach((doc) => {
            let songStructure = {
              id: doc.id,
              Artist: doc.data().Artist,
              Branch: doc.data().Branch,
              Generation: doc.data().Generation,
              Name: doc.data().Name,
              Type: doc.data().Type,
            }
            //console.log(songStructure)
            songsArray.push(songStructure)
          });
          const shuffled = shuffle(songsArray)

          localStorage.setItem('songs', JSON.stringify(shuffled))
          localStorage.setItem('lastUpdated', JSON.stringify(lastUpdated))
          
          let filteredSongs = shuffled.filter(filterSong)
          setSongsContext(filteredSongs)
          if (gamemode === 'standard') { 
            const spliced = filteredSongs.toSpliced(options.numberOfSongs)
            setSongs(spliced)
          }else{
            setSongs(filteredSongs)
          }
        }

        if (lastUpdated) {
          if(!songsCache || lastUpdatedCache < lastUpdated){ //check if cache is up to date with db
            fetchSongs()
            console.log('cache updated')
          }else{
            let filteredSongs = songsCache.filter(filterSong)
            setSongsContext(filteredSongs)
            const shuffled = shuffle(filteredSongs)
            //console.log(shuffled)
            
            if (gamemode === 'standard') { 
              const spliced = shuffled.toSpliced(options.numberOfSongs)
              setSongs(spliced)
            }else{
              setSongs([...shuffled])
            }
          }
          loaded = true
        }

      }
      
      return () => {
        loaded = false
      }
    }, [lastUpdated])
    
    useEffect(() => {
      if(songs.length > 0){
        
        let YTID = songs[0].id; //Gets a random song YTID
        
        setCurrentSong(`${songs[0].Name} by ${songs[0].Artist}`)
        
        //console.log(`ytid = ${YTID}`)
        setYTID(YTID)
      }
      console.log(songs)

    }, [songs])

    useEffect(() => {
      if(YTID){
        //console.log(songs[0].data().Name)
        loadVideo(YTID)
      }
    
      return () => {
        
      }
    }, [YTID])

    useEffect(() => {
      if(player){
        startGuess()
      }
    }, [player])

    useEffect(() => {
      console.log(`volume: ${volume}`)
      if(player)
        player.setVolume(volume)
    }, [volume])

    function handleVolume(value) {
      setVolume(value)
    }
        
    function onReady(event) {
      // access to player in all event handlers via event.target
      event.target.setVolume(volume)
      setPlayer(event.target)
    }

    function startGuess(){
      setTimeout(() => {
        duration = player.getDuration()
        if(duration > 0){
          let start = guessLenght(guesstime, duration)
          player.seekTo(start, true)
        }
      }, 1000);
    }
  
    function guessLenght(guesstime, duration) {
      var start = Math.random() * (duration - 0) + 0 // 0 means the start of the music (can be changed later)
      if (start >= guesstime)
        start -= guesstime
      console.log(`start: ${start}`)
      return start
    }

    function scorePoints() {
      console.log(`song: ${currentSong}, answer: ${answerContext}`)
      setShowAnswer(true)

      setTimeout(() => {
        setShowAnswer(false)
      }, 2500);
      if(currentSong === answerContext){
        setScore(score+1)
        setIsRight(true)
      }else{
        setIsRight(false)
        if (gamemode != 'standard') {
          loseLives()
        }
      }
    }

    useEffect(() => {
      console.log(`answer useeffect: ${answerContext}`)
    
      return () => {
        
      }
    }, [answerContext])
    
  
    // 5. The API calls this function when the player's state changes.
    //    The function indicates that when playing a video (state=1),
    //    the player should play for six seconds and then stop.
    function onPlayerStateChange(event) {
      let last = false
      if (event.data === YouTube.PlayerState.PLAYING) {
        setSongIndex(songIndex+1)
        setIsRight(null)
        playerTimeout = setTimeout(pause, guesstime*1000); // ms to ss
        
      }else if (event.data === YouTube.PlayerState.PAUSED) {
        scorePoints()
        if(songs.length > 1 && (!livesCounter || livesCounter > 1)){ //the state only refreshes after so this is a temp solution
          
          setTimeout(() => {
            songs.shift()
            setSongs([...songs])
          }, 3000);
        }else{
          console.log('last')
          last = true
          setPlayerStatus(0)
        }

      }else if (event.data === YouTube.PlayerState.CUED) {
        startGuess()
      }else if (event.data === YouTube.PlayerState.BUFFERING) {
        console.log('buffering')
      }

      if(!last)
        setPlayerStatus(event.data)
    }
    function stop() {
      player.stopVideo();
    }
    function pause() {
      player.pauseVideo();
    }
  
    function play(){
      player.playVideo()
    }

    function loadVideo(id){
      if(player){
        try {
          player.cueVideoById(id)        
          
        } catch (error) {
          console.log(error)
        }
      }
    }

    function shuffle(array) {
      let currentIndex = array.length;
      let tempArray = array
    
      // While there remain elements to shuffle...
      while (currentIndex != 0) {
    
        // Pick a remaining element...
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
    
        // And swap it with the current element.
        [tempArray[currentIndex], tempArray[randomIndex]] = [
          tempArray[randomIndex], tempArray[currentIndex]];
      }
      return tempArray
    }

    function onPlayerError(error) {
      console.log(error)
      skip(error)
      setPlayerStatus(999)
    }

    function skip(error) {
      console.log('SKIPPING')
      if (playerStatus === 1 && player) {
        pause()
      }else if (error) {
        setTimeout(() => {
          songs.shift()
          setSongs([...songs])
        }, 1000);
      }

      clearTimeout(playerTimeout)
    }

    function renderLives(maxLives) {
      var liveIcons = []
      for (let index = 0; index < maxLives; index++) {
        liveIcons.push(<FavoriteIcon className='life'/>) 
      }
      setLives(liveIcons)
    }

    function loseLives() {
      var liveIcons = lives
      for (let index = 0; index < liveIcons.length; index++) {
        const element = liveIcons[index];
        if (index === liveIcons.length-1 && element.props.className === "life") { //last
          liveIcons.pop()
          liveIcons.push(<FavoriteBorderIcon className='no-life'/>)
          console.log('losing first live')
        }else if (liveIcons[index+1] && liveIcons[index+1].props.className === "no-life") {
          liveIcons[index] = <FavoriteBorderIcon className='no-life'/>
        }
      }
      setLivesCounter(livesCounter-1)
      setLives([...liveIcons])
    }

    useEffect(() => {
      if(lives)
        lives.forEach((component) => {console.log(component.props.className)})
    
    }, [lives])
    

    return (
      <div id="player" className='player'>
        
        <div>
          <div className="controls">
            <div>
              <img src="/skip_next.svg" alt="" onClick={() => skip()} className={playerStatus != 1 ? 'wip' : null}/>
              <img src="/pause.svg" alt="" className='wip'/>
            </div>
            <Box className='volume' sx={{ width: 200 }}>
              <Stack spacing={2} direction="column" sx={{ height: 200 }} alignItems="center">
                {/* <VolumeDown /> */}
                <Slider  
                    sx={{
                      '& input[type="range"]': {
                        WebkitAppearance: 'slider-vertical',
                      },
                      'color': 'white'
                    }}
                    orientation="vertical" aria-label="Volume" value={volume} onChange={(e) => handleVolume(e.target.value)} 
                    />
                <VolumeUp />
              </Stack>
            </Box>
          </div>

          <BlockVideo guesstime={guesstime} status={playerStatus} isRight={isRight} showAnswer={showAnswer} currentSong={currentSong}/>
          {<YouTube className='video-player' videoId={YTID} opts={opts} onReady={onReady} onStateChange={onPlayerStateChange} onError={(e) => onPlayerError(e)}/>}

          <Stack direction="column" className='lives'>
            {gamemode != 'standard' ? lives : null}
          </Stack>
        </div>
      </div>
    )
  }

  function BlockVideo({status, guesstime, isRight, showAnswer, currentSong}) {
    //const [countdown, setCountdown] = useState(guesstime)
    const [answerIcon, setAnswerIcon] = useState(null)
    const [replay, setReplay] = useState(null)

    const {songIndex} = useContext(GameContext)
    const navigate = useNavigate()

    useEffect(() => {
      console.log(status)
      /* 
      if(status === 1){
        countdown > 0 && setTimeout(() => setCountdown(countdown - 1), 1000);
      }else if (countdown != guesstime){
        setCountdown(guesstime)
      } */

      if(isRight){
        setAnswerIcon("check_circle")
      }else if(isRight === false && status != 0){
        setAnswerIcon("cancel")
      }

      if(status === 0){
        setTimeout(() => {
          setAnswerIcon(null)
          setReplay(<img className='is-right replay' src='/replay.svg' alt="" onClick={() => navigate(0)}/>)
        }, 3000);
      }
    }, [status, isRight]);

    const countdown = 
      <CountdownCircleTimer
        isPlaying
        duration={guesstime}
        colors={['#FFFFFF']}
      >
        {({ remainingTime }) => (
          <span className="countdown">
            {remainingTime}
          </span>
        )}
      </CountdownCircleTimer>
    
        
    return (
      <>
        <div className="overlay overlay-player"></div>
        <div className="block-video p-absolute">
          <p>{showAnswer ? currentSong : status === 0 ? "REPLAY" : "Which song is playing now?"}</p>
          {<h1>{status === 1 ? countdown :
          (status === -1 || status === 0) ? null :
          status === 999 ? "Skipping due to an error" : <CircularProgress className='loading' />}</h1>}
          { (isRight != null && answerIcon != null) ? <img className='is-right' src={`/${answerIcon}.svg`} alt="" /> : 
          (songIndex === 0 && status === -1) ? <CircularProgress className='loading-first' /> : null}
          {replay}
        </div>
      </>
    )
  }